const ConfigApp = {
    URL: "https://app.writeprofessionalmedia.com/backend/",
    // URL: "http://localhost:3001/",
  
    CONTACTEMAIL: "",
  
    DEFAULTLANG: "en",
  
    IMAGE_URL: "https://app.writeprofessionalmedia.com/backend",
    // IMAGE_URL: "http://localhost:3001",
    SOCKET_URL: "",
    // ADMIN_AUTH_TOKEN_KEY: "M_I_N_A_T",
  
    // ROOT_PATH: "/",
  };
  
  export default ConfigApp;